<template>
  <v-container fluid :class="$style['container']">
    <v-overlay :value="loading || processing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <ToolBar :class="$style['container-header']">
      <template v-slot:left>
        <Breadcrumb :items="breadcrumbs" />
      </template>
      <template v-slot:right>
        <div class="d-flex align-center">
          <v-btn
                class="mx-1"
                small
                color="success"
                max-height="36"
                depressed
                @click="openDialog"
          >
            運営会社へ問い合わせる
          </v-btn>
        </div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon @click="onRefresh" v-on="on">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>再読込</span>
        </v-tooltip>
      </template>
    </ToolBar>
    <div :class="$style['container-content']">
      <v-content class="app-content">
        <div :class="$style['main-content']" id="messages-area">
          <template v-if="loaded">
            <template v-if="error">
              <div :class="$style['container-error']">
                <p>
                  <v-icon color="red darken-2">mdi-alert-circle</v-icon>
                  <span>エラーが発生しました</span>
                </p>
                <v-btn @click="onBack">戻る</v-btn>
              </div>
            </template>
            <template v-else>
              <CCard bodyWrapper>

                <CContainer>
                <transition-group name="chat" tag="div" class="list content">
                  <section v-for="{ text, url, userId, messageType, makerAdminId, isSystemMessage, key, createdAt } in chat" :key="key" class="item">
                    <CRow :alignHorizontal="userId === uid || isSystemMessage ? 'end' : 'start'" v-if="messageType">
                    <!-- 自分を右寄せにする -->
                    <CCard :align="userId === uid || isSystemMessage ? 'right' : 'left'"
                       :class="userId === uid || isSystemMessage ? $style['chat-right'] : $style['chat-left']">
                      <CCardBody>
                        <div class="item-image" v-if="userId !== uid && !isSystemMessage"><img :src="entity.image" width="40" height="40"></div>
                        <div class="item-detail">
                          <div class="item-name" v-if="!isSystemMessage">{{ userId === uid ? administrators[makerAdminId] : entity.user_name  }}</div>
                          <div class="item-name">{{ userId !== uid && !isSystemMessage ? userStatusName(entity.user_status) :  ""  }}</div>
                          <div class="item-message">
                              <nl2br v-if="messageType !== 'IMAGE'" tag="div" :text="text"/>
                              <CImg
                                      v-if="messageType === 'IMAGE'"
                                      :src="url"
                                      block
                                      class="mb-2"
                                      style="max-width: 500px; margin-top: 5px"
                                      :align="userId === uid ? 'right' : 'left'"
                              />
                              <CButton v-if="userId === uid" color="danger" size="sm" style="margin: 5px;float:right;clear: both;"
                              @click="deleteMessage(key)">
                                削除
                              </CButton>
                              <div style="clear: both;height:1px;"></div>
                              <nl2br tag="div" :text="format(createdAt, 'YYYY.MM.DD HH:mm:ss')"/>
                            </div>
                        </div>
                      </CCardBody>
                    </CCard>
                    </CRow>
                  </section>
                </transition-group>
                </CContainer>

              </CCard>
            </template>
          </template>
        </div>
     <div v-if="loaded && !error" :class="$style['container-footer']">
          <v-toolbar style="padding: 10px; height: 140px">
            <CContainer style="margin-top: 50px">
              <CRow>
                <CCol md="10">
                  <CContainer style="padding: 0 15px">
                    <CRow>
                    <!-- 入力フォーム -->
                      <CCol md="12" style="padding: 0px">
                        <CTextarea
                                v-model="input"
                                :disabled="!uid"
                                style="width:100%;margin-right: 25px;margin-bottom: 0px"
                        ></CTextarea>
                        <v-file-input
                                class="file-field"
                                chips
                                @change="inputFile"
                                v-if="view"
                        />
                      </CCol>
                    </CRow>
                  </CContainer>
                </CCol>

                <CCol md="2">
                  <CButton :disabled="!this.uid || ((!input || !input.match(/\S/g)) && !file.name)"
                           color="primary"
                           size="lg"
                           @click="doSend">送信</CButton>
                </CCol>
              </CRow>
            </CContainer>
          </v-toolbar>
        </div>
      </v-content>
    </div>

    <InquiryDialog :resourceName="resourceName" />
  </v-container>
</template>

<script>
  // firebase モジュール
  import {db} from '../../plugins/firebase';
  import {auth} from '../../plugins/firebase';
  import {fieldValue} from "../../plugins/firebase";
  import moment from 'moment';
  // 改行を <br> タグに変換するモジュール
  import Nl2br from 'vue-nl2br'

  import ToolBar from "@/components/app/toolbar";
  import utility from "@/utility";
  import Breadcrumb from "@/components/app/breadcrumb";

  import InquiryDialog from "@/components/dialogs/inquiry-dialog";

  import axios from "@/axios";

  export default {
    components: {
      Nl2br,
      ToolBar,
      Breadcrumb,
      InquiryDialog
    },
    props: {
      pk: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        resourceName: "message",
        user: {},
        chat: [],  // 取得したメッセージを入れる配列
        input: '',  // 入力したメッセージ
        file: {},
        params: {},
        view: true,
        file_name: ''
      }
    },
    computed: {
      entity() {
        return this.$store.getters[`${this.resourceName}/entity/entity`];
      },
      loading() {
        return this.$store.getters[`${this.resourceName}/entity/isLoading`];
      },
      loaded() {
        return this.$store.getters[`${this.resourceName}/entity/isLoaded`];
      },
      processing() {
        return this.$store.getters[`${this.resourceName}/entity/isProcessing`];
      },
      error() {
        return this.$store.getters[`${this.resourceName}/entity/error`];
      },
      breadcrumbs() {
        return [
          {
            text: "メッセージ管理",
            disabled: false,
            to: `/${this.resourceName}`
          },
          {
            text: "メッセージ詳細",
            disabled: true
          }
        ];
      },
      uid() {
        return this.$store.getters["auth/uid"];
      },
      administrators() {
        return this.$store.getters[`${this.resourceName}/entity/administrators`];
      }
    },
    created() {
      this.$store.commit(`${this.resourceName}/entity/initialize`);
    },
    methods: {
    onRefresh() {
      this.$store.dispatch(`${this.resourceName}/entity/show`, {
        pk: this.pk
      }).then(() => {

        this.getChat();

        this.$store.dispatch(`${this.resourceName}/entity/read`, { pk: this.pk })
          .then(() => {
            db.collection('Chats').doc(this.entity.chat_id).update({
              ['unreadMessages' + this.entity.maker_id]: []
            });
          });
      });

      this.$store.dispatch(`${this.resourceName}/entity/administrators`, {});
    },
      onBack() {
        this.$router.push({ path: `/${this.resourceName}` });
      },
      // スクロール位置を一番下に移動
      scrollBottom() {
        var container = this.$el.querySelector("#messages-area");
        if(container) {
          container.scrollTop = container.scrollHeight;
        }
      },
      doSend() {
        if (auth.currentUser.uid && this.input.length) {
          // firebase にメッセージを追加
          db.collection('Chats/' + this.entity.chat_id + '/Messages').add({
            text: this.input,
            makerAdminId: this.entity.maker_admin_id,
            url: '',
            userId: auth.currentUser.uid,
            messageType: 'TEXT',
            createdAt: moment().valueOf(),
            updatedAt: moment().valueOf(),
            deleteFlg: false,
            isShow: true
          }).then((document) => {
            this.params = {
              latest_text: this.input,
              type: 'text'
            }
            this.$store
              .dispatch(`${this.resourceName}/entity/add`, {
                pk: this.pk,
                addEntity: this.params
              })
              .then(() => {
                db.collection('Chats').doc(this.entity.chat_id).update({
                  ['unreadMessages' + this.entity.user_hash]: fieldValue.arrayUnion(document.id)
                });

                this.input = '' // フォームを空にする
                this.getChat();
              })
          })
        }
        this.doSendFile();
      },
      doSendFile() {
        if (this.uid && this.file.constructor !== Object) {
          let formData = new FormData();
          formData.append("file", this.file);
          axios
            .postUpload("file", formData)
            .then(response => {
              if (response.data) {
                this.$store
                  .dispatch(`${this.resourceName}/entity/file`, {
                    image: response.data.data
                  })
                  .then(response => {
                    this.file_name = response.data.image_url;
                    // firebase にメッセージを追加
                    db.collection('Chats/' + this.entity.chat_id + '/Messages').add({
                      text: '',
                      makerAdminId: this.entity.maker_admin_id,
                      url: this.file_name,
                      userId: auth.currentUser.uid,
                      messageType: 'IMAGE',
                      createdAt: moment().valueOf(),
                      updatedAt: moment().valueOf(),
                      deleteFlg: false,
                      isShow: true
                    }).then((document) => {
                      this.params = {
                        latest_image: this.file_name,
                        type: 'image'
                      }
                      this.$store
                        .dispatch(`${this.resourceName}/entity/add`, {
                          pk: this.pk,
                          addEntity: this.params
                        })
                        .then(() => {
                          db.collection('Chats').doc(this.entity.chat_id).update({
                            ['unreadMessages' + this.entity.user_hash]: fieldValue.arrayUnion(document.id)
                          });

                          this.reset();
                          this.file = {}; // フォームを空にする
                          this.getChat();
                        })
                    })
                  });
              }
            })

        }
      },
      deleteMessage(key) {
        if (this.uid) {
          utility
            .$confirm("削除しますか？", "確認", {
              confirmButtonText: "OK",
              cancelButtonText: "Cancel",
              type: "warning",
              center: true
            })
            .then(() => {
              let i = this.chat.map(item => item.key).indexOf(key);
              this.chat.splice(i, 1);
              // firebase のメッセージを削除
              db.collection('Chats/' + this.entity.chat_id + '/Messages').doc(key).delete();
            });
        }
      },
      inputFile(file){
          this.file = file
      },
      openDialog() {
        this.$store.commit(`${this.resourceName}/list/open`);
      },
      userStatusName(value) {
        switch (value) {
          case 0:
            return "";
          case 1:
            return "退会しています";
          case 2:
            return "削除されています";
          default:
            return "";
        }
      },
      // ファイル名のリセット
      reset() {
        this.view = false;
        this.$nextTick(function () {
          this.view = true;
        })
      },
      getChat(){
        const ref_message = db.collection('Chats').doc( this.entity.chat_id).collection('Messages');
        auth.currentUser.getIdToken().then((idToken) => {
          this.chat = [];
          ref_message.orderBy('createdAt').get()
            .then(querySnapshot => {

              querySnapshot.forEach(doc => {

                const data = doc.data();
                data['key'] = doc.id;
                this.chat.push(data);

              });

            }).catch((e) => {
              this.chat = [];
          });
        }).catch((e) => {
          this.chat = [];
        });
      },
      format(value, format) {
        return moment(value).format(format);
      }
    },
    mounted() {
      this.$store.dispatch(`${this.resourceName}/entity/show`, {
        pk: this.pk
      }).then(() => {

        this.getChat();

        this.$store.dispatch(`${this.resourceName}/entity/read`, { pk: this.pk })
          .then(() => {
            db.collection('Chats').doc(this.entity.chat_id).update({
              ['unreadMessages' + this.entity.maker_id]: []
            });
          });
      });

      this.$store.dispatch(`${this.resourceName}/entity/administrators`, {});
    }
  }
</script>

<style module lang="scss">
  $base-app-header-height: 75px;
  $base-header-height: 55px;
  $base-footer-height: 140px;

  .container.container {
    width: 100%;
    height: calc(100% - #{$base-app-header-height});
    padding: 0;
    position: relative;

    .container-header {
      height: $base-header-height !important;
    }

    .container-content {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      height: calc(100% - #{$base-header-height});
      overflow: hidden;

      .main-content {
        height: calc(
                100vh - #{$base-header-height} - #{$base-footer-height}
        );
        padding: 8px;
        overflow-y: auto;
        overflow-x: hidden;
      }

      .container-error {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        p {
          color: #ff0000;
          i {
            margin: 0 10px 0 0;
          }
          i,
          span {
            vertical-align: middle;
          }
        }
      }
    }

    .container-footer {
      height: $base-footer-height !important;
    }

    .chat-left, .chat-right {
      position: relative;
      display: inline-block;
    }

    .chat-left:before {
      content: '';
      position: absolute;
      display: block;
      z-index: 1;
      border-style: solid;
      border-color: transparent #d8dbe0;
      border-width: 10px 10px 10px 0;
      top: 50%;
      left: -10px;
      margin-top: -10px;
    }
    .chat-right:before {
      content: '';
      position: absolute;
      display: block;
      z-index: 1;
      border-style: solid;
      border-color: transparent #d8dbe0;
      border-width: 10px 0 10px 10px;
      top: 50%;
      right: -10px;
      margin-top: -10px;
    }
  }

</style>